import React from "react";
import style from "./Order.module.scss";
import { renderTradeQuantity, renderTradeSide, renderTradeSymbol, renderTradePrice } from "./Item";
import { getProductTypeName } from "../../utils/Order/Order";

export default class TradeInlineDetail extends React.Component {
  render() {
    const { trade, hideAvg } = this.props;

    if (trade) {
      return (
        <div className={style.detail}>
          <span>{getProductTypeName(trade.TradeAssetClassForm)}</span> <span>{renderTradeSide(trade)}</span>{" "}
          {renderTradeQuantity(trade)} {renderTradeSymbol(trade)}
          {" @ "}
          {renderTradePrice(trade)}
        </div>
      );
    } else {
      return null;
    }
  }
}
